import styled from '@emotion/styled';
import VerticalMoveIcon from 'src/assets/icons/VerticalMoveIcon';

export const SportMarketTemplatesList = styled('ul', { label: 'SportMarketTemplatesList' })`
    max-height: 690px;
    list-style-type: none;
    margin: 0;
    overflow-y: scroll;
    padding: 0;
`;

export const SportMarketTemplatesListItem = styled('li', { label: 'SportMarketTemplatesListItem' })<{ isDragged: boolean; isGenius: boolean }>`
    background-color: #eee;
    box-shadow: ${(props): string => props.isGenius ? 'inset 3px 0 0 #6c5ce7' : 'none'};
    border: 1px solid rgba(0, 0, 0, .2);
    color: #333;
    cursor: pointer;
    font-size: 12px;
    padding: 8px 10px;
    width: 100%;
    z-index: ${(props): string => props.isDragged ? '10001' : 'inherit'};

    :hover,:focus {
        background: #f3f3f3;
    }
`;

// SportCompetitionsItem
export const ItemButton = styled('span', { label: 'ItemButton' })<{ isDragged: boolean }>`
    cursor: ${(props): string => props.isDragged ? 'grabbing' : 'grab'};
    display:flex;
`;

export const ItemWrapper = styled('div', { label: 'ItemWrapper' })`
    /* display: flex; */
    justify-content: space-between;
`;

export const VerticalMoveIconWrapper = styled(VerticalMoveIcon, { label: 'VerticalMoveIconWrapper' })`
    position: absolute;
    right: 10px;
    top: 13px;
`;
